import type { ReactNode } from 'react';

import type { Colors } from '../../utils';
import { Spacer } from '../Layout';
import { Text } from '../Text';

type ButtonTextOrIconProps = {
  isLoading: boolean;
  icon: JSX.Element;
  textColor: Colors;
  children: ReactNode;
};

export const ButtonTextOrIcon = ({ isLoading, icon, textColor, children }: ButtonTextOrIconProps) => {
  return (
    <Spacer style={{ display: 'flex', justifyContent: 'center' }}>
      {isLoading && <Spacer style={{ position: 'absolute' }}>{icon}</Spacer>}
      <Spacer style={{ userSelect: 'none' }}>
        {isLoading ? <Text color="transparent">{children}</Text> : <Text color={textColor}>{children}</Text>}
      </Spacer>
    </Spacer>
  );
};
